export function WorldsPreview(): JSX.Element {
  return (
    <div className="appearance-preview preview-worlds">
      <i />
      <div>
        <b />
        <section>
          <span />
          <span />
          <span />
        </section>
        <span />
      </div>
    </div>
  );
}
